$(document).ready(function(){

  $('body').on('click', '.rq-quickshop-set-thumb-active', function(){  
   $(".rq-quickshop-set-thumb .gbproduct-gallery__thumbnail").removeClass("is-nav-selected");   
    $(this).addClass("is-nav-selected"); 
 });
  
//RQ! code for 'Currency and Language dropdowns' STARTS  
   $(".rq-hide-onload").hide();
   //$(".rq-full-main-slide-lang-curr").hide();
   setTimeout(function () {
     $(".rq-hide-onload").show();
     //$(".rq-full-main-slide-lang-curr").show();
   }, 500);   
   setTimeout(function () {
     $(".rq-hide-onload2").show();
   }, 800); 
   $(".rq-lang-and-currency-one .SelectButton").click(function(){
     var getval = $(this).attr('aria-expanded');
     if(getval == 'false'){
        $("#header-currency-popover").attr('aria-hidden', 'false');
        $(this).attr('aria-expanded', 'true');
     } else {
        $(this).attr('aria-expanded', 'false');
        $("#header-currency-popover").attr('aria-hidden', 'true')
     } 
  });
  	//RQ! code for 'Currency and Language dropdowns' ENDS

  // RQ! swatch condtions for "swatch-color_" START
  var gb = $("li").closest(".rq-ul-color-swatch").find(".rq-have-tag-swatch").html();
  if(gb) {
     $(".rq-have-tag-swatch").closest("li.HorizontalList__Item.rq-color-margin").find(".rq-no-have-tag-swatch").hide();
  }
	// RQ! swatch condtions for "swatch-color_" ENDS
  
  // RQ! Blog condition for title block STARTS
  $("div.html-section:has(.rq-padding-fix)").addClass( "rq-padding-fix-contnr" );
	// RQ! swatch condtions for "swatch-color_" ENDS
  
});

 
/*RQ! added code for 'First image of products for Boost's loop' STARTS*/
  $(document).ready(function($) {
        $(document).on('mouseover','.rq-get-hover', function(){  
            var rq_getimg = $(this).closest("li.HorizontalList__Item.rq-color-margin").find('.rq-get-changeimage').attr('src');
           
            $(this).closest(".js-product_section").find(".rq-first-img-hover").attr('src', rq_getimg);
            $(this).closest(".js-product_section").find(".rq-first-img-hover").attr('data-src', rq_getimg);
    		$(this).closest(".js-product_section").find(".rq-first-img-hover").attr('srcset', rq_getimg);
    		$(this).closest(".js-product_section").find(".rq-first-img-hover").attr('data-srcset', rq_getimg);
    		 
            //$(this).closest(".js-product_section").find(".secondary").attr('src', rq_getimg);
            //$(this).closest(".js-product_section").find(".secondary").attr('data-src', rq_getimg);
    		//$(this).closest(".js-product_section").find(".secondary").attr('srcset', rq_getimg);
    		//$(this).closest(".js-product_section").find(".secondary").attr('data-srcset', rq_getimg);
    		  
            
          //$(this).attr('src', src);
    	});
        $(document).on('mouseout','.rq-new-color-space', function(){
        //$(document).on('mouseout','.rq-get-hover', function(){
            var rq_getimg = $(this).find('.rq-orignal-img-frist-show').attr('src');
    		//var rq_getimg = $(this).closest(".rq-new-color-space").find('.rq-orignal-img-frist-show').attr('src');
             $(this).closest(".js-product_section").find(".rq-first-img-hover").attr('src', rq_getimg);
             $(this).closest(".js-product_section").find(".rq-first-img-hover").attr('data-src', rq_getimg);
    		 $(this).closest(".js-product_section").find(".rq-first-img-hover").attr('srcset', rq_getimg);
    		 $(this).closest(".js-product_section").find(".rq-first-img-hover").attr('data-srcset', rq_getimg);
    	});	
}); 
/*RQ! added code for 'First image of products for Boost's loop' ENDS*/

$(document).ready(function($) {
  setTimeout(function () { 
    //$('.message-header').show();
  }, 500);  
});

/*RQ! added code for 'Header overlay change' STARTS*/
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
         $(".header-sticky-wrapper").addClass("rq-white-header");
    } else {
        $(".header-sticky-wrapper").removeClass("rq-white-header");
    }
});
/*RQ! added code for 'Header overlay change' ENDS*/


/*RQ! added code for 'PLP Swatch Update' STARTS*/
/*$(document).ready(function() {
  //$(".boost-pfs-filter-products .rq-ul-color-swatch img").hover(function(){
  $('body').on('mouseover', '.boost-pfs-filter-products .rq-ul-color-swatch img', function(){  
    var get_image_add = $(this).closest(".geturlfull ").find('.rq-get-hover-images').attr('src');
    $(this).closest(".js-product_section").find(".product-image__wrapper .image-element__wrap.boost-pfs-action-overlay img").attr('srcset', get_image_add);
  });
});*/
/*RQ! added code for 'PLP Swatch Update' STARTS*/
$(document).on({
    mouseenter: function () {
        var get_image_add = $(this).closest(".geturlfull").find('.rq-get-hover-images').attr('src');
        $(this).closest(".boost-sd__product")
          .find(".boost-sd__product-image-img--main")
          .attr('src', get_image_add)
          .attr('srcset', get_image_add);
    },
    mouseleave: function () {
        var get_image_add = $(this).closest(".rq-ul-color-swatch")
          .find('.geturlfull.rq-border-color-boxes .rq-get-hover-images').attr('src');
        $(this).closest(".boost-sd__product")
          .find(".boost-sd__product-image-img--main")
          .attr('src', get_image_add)
          .attr('srcset', get_image_add);
    }
}, ".boost-sd__product-list .rq-ul-color-swatch img");
/*RQ! added code for 'PLP Swatch Update' ENDS*/

/*$(document).ready(function(){
const $accordionHeading = $('.accordion > dt > a, [data-cc-accordion] > dt > a');
    $('.accordion > dd, [data-cc-accordion] > dd').attr('aria-hidden', true);
    $accordionHeading.attr('aria-expanded', false);
    $accordionHeading.on('click', function () { 
      let state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
    $accordionHeading.on('keydown', function (event) {
      let keyCode = event.keyCode || e.which;

      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
});    */

/*RQ! added code for 'Collection filters' STARTS*/


$(document).ready( function(){
    $('.rq-filter-toggle').click( function() {
        $('.rq-main-faceted').addClass('rq-left-to-right');
    });

     $('.rq-closed-filter').click( function() {
        $('.rq-main-faceted').removeClass('rq-left-to-right');
    });
});

/*$(document).ready( function(){
  $('.sidebar__block').click( function() {
    $('.sidebar__block').removeClass('is-active');
    $('.sidebar__block').attr('aria-expanded', false);
    $('.sidebar__block').find('[data-sidebar-block__content--collapsible]').slideUp();
  });
});*/

      
/*RQ! added code for 'Collection filters' ENDS*/